import type { ComponentType } from 'react';
import { createElement } from 'react';

import type { View, ViewKind } from '../types';

import { ArrayRenderer } from './ArrayRenderer';
import { GridRenderer } from './GridRenderer';
import { LinkedListRenderer } from './LinkedListRenderer';
import { TreeRenderer } from './TreeRenderer';
import { GraphRenderer } from './GraphRenderer';
import { StackRenderer } from './StackRenderer';
import { NoteRenderer } from './NoteRenderer';
import { DiagramRenderer } from './DiagramRenderer';

/* eslint-disable @typescript-eslint/no-explicit-any */
export const VIEW_RENDERERS: Record<ViewKind, ComponentType<{ view: any }>> = {
  array: ArrayRenderer,
  grid: GridRenderer,
  linkedlist: LinkedListRenderer,
  tree: TreeRenderer,
  graph: GraphRenderer,
  stack: StackRenderer,
  note: NoteRenderer,
  diagram: DiagramRenderer,
};
/* eslint-enable @typescript-eslint/no-explicit-any */

/**
 * Dispatches on the discriminant. An unknown kind renders nothing rather than
 * throwing — a malformed script should degrade to a blank stage, never take the
 * lesson page down with it.
 */
export function ViewRenderer({ view }: { view: View }) {
  const Renderer = VIEW_RENDERERS[view?.kind];
  if (!Renderer) return null;
  return createElement(Renderer, { view });
}

export { ArrayRenderer, GridRenderer, LinkedListRenderer, TreeRenderer, GraphRenderer, StackRenderer, NoteRenderer, DiagramRenderer };
